// extracted by mini-css-extract-plugin
export default {"modal__buttonSection":"styles_modal__buttonSection__Xd4Rr"};